import PropTypes from "prop-types";
import React, { useEffect } from "react";

import { Row, Col, CardBody, Card, Alert, Container, Form, Input, FormFeedback, Label, Button } from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import { Link } from "react-router-dom";
import withRouter from "components/Common/withRouter";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { loginUser, socialLogin } from "../../store/actions";

// import images
import profile from "assets/images/profile-img.png";
import logo from "assets/images/logo.svg";
import ShreeRamImage from '../../components/Common/ShreeRamImage';

const Login = props => {

  document.title = "Login | Welcome";

  const dispatch = useDispatch();

  const validation = useFormik({
    // enableReinitialize : use this  flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: "" || '',
      password: "" || '',
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: (values) => {
      dispatch(loginUser(values, props.router.navigate));
    }
  });


  const LoginProperties = createSelector(
    (state) => state.Login,
    (login) => ({
      error: login.error
    })
  );

  const {
    error
  } = useSelector(LoginProperties);

  const signIn = type => {
    dispatch(socialLogin(type, props.router.navigate));
  };

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return (
    <React.Fragment>
      <div
        className="account-pages"
        style={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          height: '100vh',
          maxHeight: '100vh',
          width: '100vw',
          maxWidth: '100vw',
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          padding: '10px 15px'
        }}
      >
        <Container fluid style={{ maxWidth: '1140px' }}>
          <Row className="justify-content-center align-items-center g-4">
            {/* Left Side - Company Design with Blue Background */}
            <Col lg={7} xl={7} className="d-none d-lg-block">
              <div className="text-center text-white px-4">
                <div className="mb-2">
                  <div
                    className="bg-white bg-opacity-20 rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                    style={{ width: '100px', height: '100px', overflow: 'hidden' }}
                  >
                    <ShreeRamImage
                      alt="Shree Ram"
                      portraitStyle={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }}
                      landscapeStyle={{ width: '100%', height: '100%', objectFit: 'contain' }}
                    />
                  </div>
                  <h2 className="fw-bold mb-2 text-white">
                    Welcome
                  </h2>
                  <div className="bg-white" style={{ height: '3px', width: '80px', margin: '0 auto 16px auto', borderRadius: '2px' }}></div>
                  <p className="lead mb-0 text-white-50 font-size-18">
                    Your Trusted Partner in Agricultural Trading
                  </p>
                </div>
              </div>
            </Col>

            {/* Right Side - Login Form */}
            <Col lg={5} xl={5} sm={10} xs={12}>
              <Card
                className="border-0 shadow-lg"
                style={{
                  borderRadius: '16px',
                  backgroundColor: 'rgba(255, 255, 255, 0.98)',
                  maxHeight: '94vh',
                  overflowY: 'auto'
                }}
              >
                <CardBody className="p-3 p-sm-4">
                  {/* Header Section */}
                  <div className="text-center mb-3">
                    <h4 className="text-dark fw-bold mb-1">
                      Welcome Back!
                    </h4>
                    <p className="text-muted mb-0 font-size-13">
                      Sign in to your account to continue
                    </p>
                  </div>

                  {/* Form Section */}
                  <Form
                    className="form-horizontal"
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    {error ? (
                      <Alert color="danger" className="border-0 shadow-sm mb-3 py-2" style={{ borderRadius: '10px' }}>
                        <i className="fas fa-exclamation-triangle me-2"></i>
                        {error}
                      </Alert>
                    ) : null}

                    {/* Email Field */}
                    <div className="mb-3">
                      <Label className="form-label fw-semibold text-dark mb-1 font-size-13">
                        <i className="fas fa-user me-2 text-primary"></i>
                        Username / Mobile Number
                      </Label>
                      <div className="position-relative">
                        <Input
                          name="email"
                          className="form-control border-2"
                          placeholder="Enter Username or 10-digit Mobile"
                          type="text"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email ? true : false
                          }
                          style={{
                            borderRadius: '10px',
                            borderColor: '#e9ecef',
                            padding: '10px 16px 10px 42px',
                            transition: 'all 0.3s ease',
                            fontSize: '14px',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.03)'
                          }}
                        />
                        <i
                          className="fas fa-user position-absolute"
                          style={{
                            left: '14px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            color: '#667eea',
                            zIndex: 10,
                            fontSize: '15px'
                          }}
                        ></i>
                      </div>
                      {validation.touched.email && validation.errors.email ? (
                        <FormFeedback type="invalid" className="d-flex align-items-center mt-1 font-size-12">
                          <i className="fas fa-exclamation-circle me-1"></i>
                          {validation.errors.email}
                        </FormFeedback>
                      ) : null}
                    </div>

                    {/* Password Field */}
                    <div className="mb-3">
                      <Label className="form-label fw-semibold text-dark mb-1 font-size-13">
                        <i className="fas fa-lock me-2 text-primary"></i>
                        Password
                      </Label>
                      <div className="position-relative">
                        <Input
                          name="password"
                          value={validation.values.password || ""}
                          type="password"
                          placeholder="Enter your password"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          invalid={
                            validation.touched.password && validation.errors.password ? true : false
                          }
                          className="form-control border-2"
                          style={{
                            borderRadius: '10px',
                            borderColor: '#e9ecef',
                            padding: '10px 16px 10px 42px',
                            transition: 'all 0.3s ease',
                            fontSize: '14px',
                            boxShadow: '0 2px 4px rgba(0,0,0,0.03)'
                          }}
                        />
                        <i
                          className="fas fa-lock position-absolute"
                          style={{
                            left: '14px',
                            top: '50%',
                            transform: 'translateY(-50%)',
                            color: '#667eea',
                            zIndex: 10,
                            fontSize: '15px'
                          }}
                        ></i>
                      </div>
                      {validation.touched.password && validation.errors.password ? (
                        <FormFeedback type="invalid" className="d-flex align-items-center mt-1 font-size-12">
                          <i className="fas fa-exclamation-circle me-1"></i>
                          {validation.errors.password}
                        </FormFeedback>
                      ) : null}
                    </div>

                    {/* Remember Me */}
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          id="customControlInline"
                          style={{ borderRadius: '4px' }}
                        />
                        <label
                          className="form-check-label text-muted fw-medium font-size-13"
                          htmlFor="customControlInline"
                        >
                          Remember me
                        </label>
                      </div>
                    </div>

                    {/* Login Button */}
                    <div className="d-grid mb-3">
                      <Button
                        className="btn btn-primary fw-semibold"
                        type="submit"
                        style={{
                          borderRadius: '10px',
                          padding: '10px',
                          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                          border: 'none',
                          boxShadow: '0 4px 15px rgba(102, 126, 234, 0.3)',
                          transition: 'all 0.3s ease',
                          fontSize: '15px'
                        }}
                        onMouseEnter={(e) => {
                          e.target.style.transform = 'translateY(-2px)';
                          e.target.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.4)';
                        }}
                        onMouseLeave={(e) => {
                          e.target.style.transform = 'translateY(0)';
                          e.target.style.boxShadow = '0 4px 15px rgba(102, 126, 234, 0.3)';
                        }}
                      >
                        <i className="fas fa-sign-in-alt me-2"></i>
                        Sign In
                      </Button>
                    </div>

                    {/* Free Trial Registration Link */}
                    <div className="text-center pt-2 pb-1 border-top">
                      <p className="text-muted mb-2 font-size-13">
                        Starting a new firm?
                      </p>
                      <Link
                        to="/register"
                        className="btn btn-outline-success w-100 fw-bold py-2 font-size-14"
                        style={{
                          borderRadius: '10px',
                          borderWidth: '1.5px',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '8px'
                        }}
                      >
                        <i className="fas fa-gift text-warning font-size-15"></i>
                        Register New Firm (7-Day Free Trial)
                      </Link>
                    </div>

                    {/* Support Helpline */}
                    <div className="mt-2 text-center">
                      <small className="text-muted font-size-12">
                        Need Help? Contact Support: <a href="tel:+919999999999" className="fw-semibold text-primary">+91 99999-99999</a>
                      </small>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>

        {/* Footer pinned at bottom */}
        <div style={{ position: 'absolute', bottom: '8px', left: 0, right: 0, textAlign: 'center' }}>
          <small className="text-white-50">
            © {new Date().getFullYear()} Welcome. All rights reserved.
          </small>
        </div>
      </div>
    </React.Fragment>
  );
};

export default withRouter(Login);

Login.propTypes = {
  history: PropTypes.object,
};
